module.exports = __webpack_public_path__ + "static/colgadas-016.thumb-103472fc7f03b70af2a33f6553f9dd50.jpg";